/* eslint-disable no-unused-vars */
import AbstractFilterBuilder from './abstract';
import productsData from '../database/products';

export default class CheckFilterBuilder extends AbstractFilterBuilder {
    items = [];

    value = [];

    test(product) {
        if (this.value.length === 0) {
            return true;
        }
       // console.log('test', product, this.value);
        return this.value.reduce((result, value) => (
            result || this.extractItems(product).map((x) => x.slug).includes(value)
        ), false);
    }

    makeItems(products, value) {
        products.forEach((product) => this.extractItems(product).forEach((item) => {
            if (!this.items.find((x) => x.name === item.name)) {
                this.items.push(item);
            }
            // console.log('makeItems', product, value, item, this.items);
        }));
       // console.log('makeItems this.items', this.items);
        this.value = this.parseValue(value);
    }

    calc(productsData1, filters) {
        const products = productsData1.filter(
            (product) => filters.reduce(
                (isMatched, filter) => (
                    isMatched && (filter.test(product))
                ),
                true,
            ),
        );
       // console.log('calc products', products, filters);
        this.items = this.items.map((item) => {
            // console.log('calc', products, filters, item);
            const count = products.reduce((acc, product) => (
                acc + (this.extractItems(product).map((x) => x.slug).includes(item.slug) ? 1 : 0)
            ), 0);

            return { ...item, count };
        });
    }

    build() {
        return {
            type: 'check',
            slug: this.slug,
            name: this.name,
            items: this.items,
            value: this.value,
        };
    }

    // eslint-disable-next-line class-methods-use-this
    parseValue(value) {
        return value ? value.split(',') : [];
    }

    extractItems(product) {
       // console.log('extractItems', this.slug, product.brand);
        if (this.slug === 'brand') {
            return product.brand ? [{
                slug: product.brand.alias,
                name: product.brand.name,
                count: 0,
            }] : null;
        }

        throw Error();
    }
}
